import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  place-items: center;
  min-height: 100vh;
`;

export const Box = styled.div`
  text-align: center;
  font-family: "Museo";

  h1 {
    ${({ theme }) => theme.typography.h1}
  }

  p {
    ${({ theme }) => theme.typography.normal}
  }
`;

export const RefreshButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: ${({ theme }) => theme.colors.grayscale[90]};
  cursor: pointer;
  font-family: "Museo";
  font-weight: 700;
  margin-top: 20px;
`;

export const ReturnButton = styled.button``;
